type ClipboardWriter<Item> = {
  write: (items: Item[]) => Promise<void>;
  writeText: (text: string) => Promise<void>;
};

type ClipboardItemConstructor<Item> = new (items: Record<string, Blob>) => Item;

// Rich editors take the HTML and keep the formatting; everything else takes the plain text.
const copyAnswer = async <Item>(
  clipboard: ClipboardWriter<Item>,
  { html, text }: { html: string; text: string },
  ClipboardItemCtor?: ClipboardItemConstructor<Item>,
): Promise<boolean> => {
  try {
    if (ClipboardItemCtor) {
      await clipboard.write([new ClipboardItemCtor({
        'text/html': new Blob([html], { type: 'text/html' }),
        'text/plain': new Blob([text], { type: 'text/plain' }),
      })]);
    } else {
      await clipboard.writeText(text);
    }
    return true;
  } catch {
    return false;
  }
};

export default copyAnswer;
